import { useMemo } from 'react';
const variantRegexp = /(primary)|(minor)|(alt-bg)|(text)|(secondary)/g;
export const useVariant = (variant) => useMemo(() => variant.match(variantRegexp) || [], [variant]);
export const useRel = (rel, target) => {
    var _a;
    const prefix = target === 'blank' && !(rel === null || rel === void 0 ? void 0 : rel.includes('noopener')) ? `noopener ` : '';
    return `${prefix}${(_a = rel === null || rel === void 0 ? void 0 : rel.join('  ')) !== null && _a !== void 0 ? _a : ''}`;
};
//# sourceMappingURL=utils.js.map